// extracted by mini-css-extract-plugin
export default {"tag":"swZWL","title":"cOXex","container":"jHVT2"};